import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Hidden,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Box,
  makeStyles,
  Link,
} from "@material-ui/core";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";

const NavBar = () => {
  const useStyles = makeStyles({
    lnk: {
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        textDecoration: "none",
      },
    },
    div: {
      display: "flex",
      marginLeft: "auto",
      alignItems: "center",
    },
    appBar: {
      background: "primary",
      color: "white",
    },
    drawerPaper: {
      width: "60%",
      backgroundColor: "#1e6cae",
      color: "white",
    },
    button: {
      background: "inherit",
      borderRadius: 3,
      color: "white",
      height: 40,
      padding: "0 1rem",
      margin: "0 0.5rem",
      fontSize: "0.9rem",
    },

    text: {
      fontSize: "1.2rem",
      color: "White",
    },
    span: {
      textShadow: "1px 1px rgba(0, 0, 0, 0.3)",
    },
    listItemText: {
      fontSize: "0.9rem",
      fontWeight: "500",
    },
  });
  const classes = useStyles();

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const getLink = (input) => {
    let words = input.split(" ");
    let linkWords = [];
    words.forEach((element) => {
      linkWords.push(
        element[0].toUpperCase() +
          element.slice(1, element.length).toLowerCase()
      );
    });
    return linkWords.join("");
  };

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  const appBarButtons = (
    <Box className={classes.div}>
      <Button className={classes.button} onClick={() => scrollTo("About")}>
        About
      </Button>
      <a
        href="/Kishore.Shiraguppi.CV.2024.pdf"
        className="MuiButtonBase-root MuiButton-root MuiButton-text makeStyles-button-12"
        target="_blank"
        rel="noopener noreferrer"
        download
        style={{ textDecoration: "none", color: "white" }} // Inline style for removing underline, adjust as needed
      >
        Resume
      </a>
      <Button className={classes.button} onClick={() => scrollTo("Projects")}>
        Projects
      </Button>
      <Button className={classes.button} onClick={() => scrollTo("Contact")}>
        Contact
      </Button>
    </Box>
  );

  const sideDrawer = (
    <Box className={classes.div}>
      <Drawer
        variant="temporary"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <List onClick={handleDrawerToggle}>
          {["ABOUT", "RESUME", "PROJECTS", "CONTACT"].map((text, index) =>
            text.toLowerCase() === "resume" ? (
              <a
                key={text} // Added a key prop here for consistency
                href="/Kishore.Shiraguppi.CV.2024.pdf"
                className="MuiTypography-root MuiListItemText-primary makeStyles-listItemText-278 MuiTypography-body1 MuiTypography-displayBlock"
                target="_blank"
                rel="noopener noreferrer"
                download
                style={{
                  textDecoration: "none",
                  display: "block",
                  padding: "8px 16px",
                  color: "white",
                }} // Adjusted styles for consistency with ListItem
              >
                {text}
              </a>
            ) : (
              <ListItem
                button
                component="a"
                key={text}
                href={"#" + getLink(text)}
              >
                <ListItemText
                  primary={text}
                  classes={{ primary: classes.listItemText }}
                />
              </ListItem>
            )
          )}
        </List>
      </Drawer>
      <IconButton onClick={handleDrawerToggle}>
        <MenuRoundedIcon />
      </IconButton>
    </Box>
  );

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Link to="/" className={classes.lnk}>
          <Typography variant="h6" className={classes.lnk}>
            Kishore Shiraguppi
            <span
              role="img"
              aria-label="sparkle emoji"
              className={classes.span}
            >
              ✨
            </span>
          </Typography>
        </Link>
        <Hidden xsDown>{appBarButtons}</Hidden>
        <Hidden smUp>{sideDrawer}</Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
